import { ref, reactive } from "@vue/composition-api"
import axios from "axios";

let orderMeta;
let configs;

export default function useProductInfo () {

    if(orderMeta == undefined){
        orderMeta = ref({});
    }
    if(configs == undefined){
        configs = reactive({});
    }
    const products = ref([]);
    const serviceContent = ref('&nbsp;');

    const getProductInfo = (id,model,type) => {
        axios({
            url: '/actions/products.cfc?method=getProductInfo',
            params: {
                id: id,
                model: model,
                type: type
            }
        }).then(function(response){
            products.value = response.data.products;
        });
    }

    const getOrderMetaData = () => {
        axios({url: '/actions/products.cfc?method=getOrderMetaData'}).then(function(response){
            orderMeta.value = response.data;
        });
    }

    const getProductServiceContent = (id) => {
        var params = new URLSearchParams({
            id: id
        });
        axios.post('/actions/products.cfc?method=getProductServiceContent',params).then(function(response){
            serviceContent.value = response.data;
        });
    }

    const initProductConfig = (productId,price1,price2) => {
        if(!configs[productId]){
            configs[productId] = {
                config: [],
                price1: price1,
                price2: price2,
                required: [],
                missingInput: [],
                cartError: false
            };
        }
    }


    return {
        getProductInfo,
        products,
        orderMeta,
        getProductServiceContent,
        serviceContent,
        initProductConfig,
        getOrderMetaData
    }
}
